module.exports = __webpack_public_path__ + "img/business-graphics-1056973-640x640.ca623af8.jpg";